/**
 * @file 讲义打印列表筛选字段
 * @description RequestTable searchForm.items：学员名称、打印状态。
 *
 * @whenToUse 仅讲义打印 RequestTable。
 * @whenNotToUse 其他业务筛选。
 */

import { Input } from '@/components/ui/input.tsx'
import type { RequestTableSearchContext } from '@/components/ui/request-table.tsx'
import { Select } from '@/components/ui/select.tsx'
import {
  HANDOUT_STATUS_LABEL,
  type HandoutPrintStatus,
  type HandoutQuery,
} from '@/components/pages/handout-page/types.ts'

const STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'pending' satisfies HandoutPrintStatus, label: HANDOUT_STATUS_LABEL.pending },
  { value: 'printed' satisfies HandoutPrintStatus, label: HANDOUT_STATUS_LABEL.printed },
]

/**
 * 讲义打印列表搜索表单项
 * @param ctx RequestTable 搜索上下文
 */
export function HandoutSearchFields({
  values,
  setField,
}: RequestTableSearchContext<HandoutQuery>) {
  return (
    <>
      <Input
        value={values.studentName}
        placeholder="学员名称"
        onChange={(event) => setField('studentName', event.target.value)}
      />
      <Select
        value={values.status}
        placeholder="打印状态"
        options={STATUS_OPTIONS}
        onChange={(value) => setField('status', value)}
      />
    </>
  )
}
